import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { Pagination } from "../../../shared/models/list.page.model";
import { ApiUserUsersPageByCompanyIdCompanyIdGet$Json$Params } from "../../../core/api/fn/user/api-user-users-page-by-company-id-company-id-get-json";
import { ApiUserCountByCompanyIdCompanyIdGet$Params } from "../../../core/api/fn/user/api-user-count-by-company-id-company-id-get";
import { ApiCompanyPageCompanyIdGet$Params } from "../../../core/api/fn/company/api-company-page-company-id-get";
import { ApiCompanyCountCompanyIdGet$Params } from '../../../core/api/fn/company/api-company-count-company-id-get';

export class CompaniesRequestUtil {
    static createCompanyListRequest(
        companyId: number | null | undefined,
        pagination?: Pagination | null
    ) : ApiCompanyPageCompanyIdGet$Params {
        return {
            companyId: companyId,
            pageIndex: pagination?.pageIndex,
            pageSize: pagination?.pageSize
        } as ApiCompanyPageCompanyIdGet$Params;
    }

    static createCompanyCountRequest(
        companyId: number | null | undefined
    ) : ApiCompanyCountCompanyIdGet$Params {
        return {
            companyId: companyId,
        } as ApiCompanyCountCompanyIdGet$Params;
    }

    static createCompanyUsersListRequest(
        companyId?: number,
        pagination?: Pagination | null
    ) : ApiUserUsersPageByCompanyIdCompanyIdGet$Json$Params {
        return {
            companyId: companyId,
            pageIndex: pagination?.pageIndex ?? 0,
            pageSize: pagination?.pageSize ?? paginationConstants.DefaultPageSize,
        } as ApiUserUsersPageByCompanyIdCompanyIdGet$Json$Params;
    }

    static createCompanyUsersCountRequest(
        companyId?: number,
    ) : ApiUserCountByCompanyIdCompanyIdGet$Params {
        return {
            companyId: companyId,
        } as ApiUserCountByCompanyIdCompanyIdGet$Params;
    }
}